import Vue from 'vue';
import ButtonBar from 'components/buttonBar/ButtonBar';

Vue.component('button-bar', ButtonBar);
